define('SuiteDynamics.HomePageHeroVideo.PromoVideo',
	[
	],
	function (
		HeroVideoView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {
			var layout = container.getComponent('Layout');
			if (layout) {
				var environment = container.getComponent('Environment');
				var promoVideoEnabled = environment.getConfig('homePageHeroVideo.promoVideoEnabled') || false;
				var promoVideoUrl = environment.getConfig('homePageHeroVideo.promoVideoUrl') || null;

				if (promoVideoEnabled && promoVideoUrl) {
					layout.addToViewContextDefinition('Home.View', 'promoVideoEnabled', 'boolean', function (context) {
						return promoVideoEnabled;
					});
					layout.addToViewContextDefinition('Home.View', 'promoVideoUrl', 'string', function (context) {
						return promoVideoUrl;
					});
				}
			}
		}
	};
});
